import { render } from "./Potentiality.vue?vue&type=template&id=7b92fc7e"
import script from "./Potentiality.vue?vue&type=script&lang=js"
export * from "./Potentiality.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__